import { apiClient } from './apiClient';

/** Current provider user: { id, username, email, role, permissions }. */
export async function getMe() {
  const { data } = await apiClient.get('/api/provider/me');
  return data;
}
